import * as React from 'react';
import { Shape } from '@root/types';
import OnlyInDesktopTablet from '@components/shared/OnlyInDesktopTablet';
import Filters from './Filters/Filters';
import Mobile from './Mobile';
import SortDropdown from './SortDropdown';
import ResultsHeaderText from './ResultsHeaderText';
import s from './Header.module.less';

type Props = {
  defaultMarketName: string | null;
  customMapCoordinates: string | null | undefined;
  hasSearchResults: boolean;
  isLoading: boolean;
  listingsCount: number;
  selectedMarkets: Shape[];
  sort: string;
  sortChanged: Function;
};

const Header = ({
  selectedMarkets,
  sortChanged,
  hasSearchResults,
  isLoading,
  defaultMarketName,
  customMapCoordinates,
  sort,
  listingsCount,
}: Props) => (
  <>
    <Mobile />
    <OnlyInDesktopTablet className={s.stickyContainer}>
      <Filters />
    </OnlyInDesktopTablet>
    <div className={s.headerContainer}>
      <ResultsHeaderText
        numListings={listingsCount}
        selectedMarkets={selectedMarkets}
        isCustomMapArea={!!customMapCoordinates}
        isLoading={isLoading}
        defaultMarketName={defaultMarketName}
      />
      <div className={s.spacer}></div>
      <SortDropdown sort={sort} disabled={!hasSearchResults} sortChanged={sortChanged} />
    </div>
  </>
);

export default Header;
